import Icon from '../components/Icon';

const Add = Icon(
  'add',
  <>
    <path d="M7.25 12a.75.75 0 0 1 .75-.75h3.25V8a.75.75 0 0 1 1.5 0v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8a.75.75 0 0 1-.75-.75" />
    <path
      fillRule="evenodd"
      d="M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5"
      clipRule="evenodd"
    />
  </>
);

export default Add;
